import React, { useCallback, useContext } from 'react';
import Button from '@material-ui/core/Button';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import { Theme } from '@material-ui/core/styles';

import { ArchivalUnitCopy } from 'types';
import { GridActionButtonComponent } from 'components/grid/grid-types';
import {
  addArchivalUnitToFavourites,
  removeArchivalUnitFromFavourites,
} from 'modules/portfolio-favourite/favourite-api';
import { NotificationCtx } from 'components/notification/notification-hook';
import { NotificationVariant } from 'components/notification/notification-types';
import { AuthCtx } from '../../components/auth/auth-ctx';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navigationButton: {
      marginTop: theme.spacing(),
      alignSelf: 'baseline',
      width: '100%',
    },
  })
);

export function ArchivalUnitFavourite({
  item,
  refreshDetail,
}: GridActionButtonComponent) {
  const classes = useStyles();
  const { userInfo } = useContext(AuthCtx);

  const { showNotification } = useContext(NotificationCtx);

  const archivalUnit = item as ArchivalUnitCopy;

  const isFavourite = Boolean(archivalUnit?.favourite);

  const handleAddToFavourites = useCallback(async () => {
    const response = await addArchivalUnitToFavourites(archivalUnit.id);

    if (response.ok) {
      showNotification(
        'Archiválie byla úspěšně přidána mezi oblíbené.',
        NotificationVariant.SUCCESS
      );
      refreshDetail();
    } else {
      showNotification(
        'Při přidávání archiválie mezi oblíbené nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [archivalUnit, showNotification, refreshDetail]);

  const handleRemoveFromFavourites = useCallback(async () => {
    const response = await removeArchivalUnitFromFavourites(archivalUnit.id);

    if (response.ok) {
      showNotification(
        'Archiválie byla úspěšně odebrána z oblíbených.',
        NotificationVariant.SUCCESS
      );
      refreshDetail();
    } else {
      showNotification(
        'Při odebíraní archiválie z oblíbených nastala chyba.',
        NotificationVariant.ERROR
      );
    }
  }, [archivalUnit, showNotification, refreshDetail]);

  return userInfo?.aisAuthenticated ? (
    <Button
      component="span"
      variant="outlined"
      color="primary"
      className={classes.navigationButton}
      onClick={isFavourite ? handleRemoveFromFavourites : handleAddToFavourites}
    >
      {isFavourite ? 'Odstraň z oblíbených' : 'Přidej k oblíbeným'}
    </Button>
  ) : (
    <></>
  );
}
